module.exports = __webpack_public_path__ + "static/media/12_good_02.26fdd615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-3/12_good_02.png
// module id = 709
// module chunks = 0